import React, { useEffect, useState } from "react"
import "./ViewPortalUser.scss"
import { useNavigate, useParams } from "react-router-dom"
import AuthenticationApi from "Api/AuthenticationApi"
import { InputText } from "primereact/inputtext"
import { Card, CardBody, Col, Row,Button } from "reactstrap"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"

const ViewPortalUser = () => {
    document.title = "View Portal User"

    const navigate = useNavigate("")
    const accessToken = localStorage.getItem("accessToken")
    const { userId } = useParams()

    const [userData, setUserData] = useState([])

    const breadcrumbItems = [
        { label: "Pixwik", link: "/" },
        { label: "Users", link: "/PortalUsers" },
        { label: "View Portal User" },
    ]
    const handleBreadcrumbClick = link => {
        if (link !== "#") {
          navigate(link)
        }
      }
    const getUserData = () => {
        const config = {
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        }
        AuthenticationApi.getPortalUserById(userId, config)
        .then(res => {
            
            setUserData(res.data.data)
        })
        .catch((err) => {
            
        })
    }

    useEffect(() => {
        if (userId) {
            getUserData()
        }
    }, [userId])

   

return(
    <div className="view-portal-user">
        <Row>
            <Col xs="12">
                <div className="category-list-header d-flex  align-items-center justify-content-between">
                    <CustomBreadCrumb
                     data={breadcrumbItems}
                    pageTitle="View Portal User"
                      handleClick={handleBreadcrumbClick}
                      />
                </div>
                <Card className="mt-4 ">
                    <CardBody>
                        <div className="view-portal-user-form">
                            <div className="view-portal-user-inp">
                                <label htmlFor="userName" className="label">
                                    User Name
                                </label>
                                <div className="inp-err">
                                    <InputText
                                     id="userName"
                                      value={userData.userName}
                                      className="inp-field-box"
                                      disabled
                                       />
                                </div>
                            </div>
                            <div className="view-portal-user-inp">
                                <label htmlFor="email" className="label">
                                    Email
                                </label>
                                <div className="inp-err">
                                    <InputText
                                     id="email"
                                      value={userData.email}
                                      className="inp-field-box"
                                      disabled
                                       />
                                </div>
                            </div>
                            <div className="view-portal-user-inp">
                                <label htmlFor="role   " className="label">
                                    Role
                                </label>
                                <div className="inp-err">
                                    <InputText
                                     id="role"
                                      value={userData.role}
                                      className="inp-field-box"
                                      disabled
                                       />
                                </div>
                            </div>
                            <div className="view-portal-user-inp">
                                <label htmlFor="UserStatus" className="label">
                                    Status
                                </label>
                                <div className="inp-err">
                                    <InputText
                                        id="UserStatus"
                                      value={userData.isActive ? "Active" : "Inactive"}
                                      className="inp-field-box"
                                      disabled
                                       />
                                </div>
                            </div>
                            <div className="view-portal-user-inp">
                                <label htmlFor="userId " className="label">
                                    User ID
                                </label>
                                <div className="inp-err">
                                    <InputText
                                     id="userId"
                                      value={userData.userId}
                                      className="inp-field-box"
                                      disabled
                                       />
                                </div>
                            </div>
                            <div className="save-cancel-btn mt-4 d-flex align-items-center justify-content-start gap-3"> 
                                <Button 
                                 type="button"
                                  outline
                                   color="danger"
                                    className="waves-effect waves-light"
                                     onClick={() => {
                                        navigate(-1)
                                     }}
                                     >
                                    Back
                                </Button>
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </Row>
    </div>

)
}

export default ViewPortalUser